exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-2d249289],\nh2[data-v-2d249289] {\n  font-weight: normal;\n}\nul[data-v-2d249289] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-2d249289] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-2d249289] {\n  color: #42b983;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d249289","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Symp_item.vue
// module id = +Ujf
// module chunks = 1